var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"color":"white"}},[_c('v-container',{staticClass:"px-16 my-4",attrs:{"fluid":""}},[_c('FormulaTable',{attrs:{"item":_vm.item}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }